module.exports = __webpack_public_path__ + "static/media/newsCard.34b4120d.png";